module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8a53fddb0dd709c111a062795a3dd790.png";